export const SELLOUT_PRICE_VS_SUGGESTED_PRICE_TABLE = "sellout_price_vs_suggested_price"
export const SOP_VS_SRP = "sop_vs_srp"
